import styled from 'styled-components';
import shopping_cart from '../../atoms/Icon/img/shopping-cart.svg';
import credit_card from '../../atoms/Icon/img/credit_card.svg';
import date from '../../atoms/Icon/img/date.svg';
import cvc from '../../atoms/Icon/img/cvc.svg';
var c_c = "url(".concat(credit_card, ");");
var card_date = "url(".concat(date, ");");
var card_cvc = "url(".concat(cvc, ");");
export var Input = styled.input.withConfig({
  displayName: "style__Input",
  componentId: "yxr7mg-0"
})(["height:50%;width:", ";color:black;border-top-right-radius:", ";border-top-left-radius:", ";border-bottom-right-radius:", ";border-bottom-left-radius:", ";padding-left:40px;border:2px solid;background-image:", ";background-repeat:no-repeat;border-color:rgba(14,19,24,0.2);&:focus{outline:0;border-color:#4cbeff;}"], function (props) {
  return props.small ? '50%' : '100%';
}, function (props) {
  return props.small ? '0px' : '4px';
}, function (props) {
  return props.small ? '0px' : '4px';
}, function (props) {
  return props.right ? '4px' : '0px';
}, function (props) {
  return props.left ? '4px' : '0px';
}, function (props) {
  return props.cvc ? card_cvc : props.date ? card_date : c_c;
});
export var InputContainer = styled.div.withConfig({
  displayName: "style__InputContainer",
  componentId: "yxr7mg-1"
})(["position:relative;height:70%;width:auto;margin-left:12px;margin-right:12px;"]);
export var CheckoutTitle = styled.div.withConfig({
  displayName: "style__CheckoutTitle",
  componentId: "yxr7mg-2"
})(["font-weight:600;line-height:2;position:relative;height:25px;width:auto;margin-left:12px;color:rgba(14,19,24,0.9);margin-right:12px;"]);
export var CheckoutContainer = styled.div.withConfig({
  displayName: "style__CheckoutContainer",
  componentId: "yxr7mg-3"
})(["height:110px;width:100%;margin-bottom:15px;"]);
export var Price = styled.div.withConfig({
  displayName: "style__Price",
  componentId: "yxr7mg-4"
})(["height:100%;width:30%;margin:auto;font-weight:600;color:rgba(14,19,24,0.9);"]);
export var Title = styled.div.withConfig({
  displayName: "style__Title",
  componentId: "yxr7mg-5"
})(["height:100%;width:70%;margin:auto;color:rgba(14,19,24,0.9);"]);
export var Item = styled.div.withConfig({
  displayName: "style__Item",
  componentId: "yxr7mg-6"
})(["height:35px;width:80%;margin:auto;color:rgba(14,19,24,0.9);flex-direction:row;display:flex;"]);
export var ExitButton = styled.div.withConfig({
  displayName: "style__ExitButton",
  componentId: "yxr7mg-7"
})(["width:20%;cursor:pointer;text-align:center;line-height:40px;background:none;border:none;font-style:normal;font-weight:300;font-size:20px;color:rgba(14,19,24,0.6);margin:auto;"]);
export var PB = styled.div.withConfig({
  displayName: "style__PB",
  componentId: "yxr7mg-8"
})(["width:150px;height:40px;cursor:pointer;text-align:center;line-height:40px;background-color:rgb(48,194,255);border-color:rgb(48,194,255);color:#fff;border-radius:4px;text-decoration:none;"]);
export var IconContainer = styled.div.withConfig({
  displayName: "style__IconContainer",
  componentId: "yxr7mg-9"
})(["display:flex;justify-content:center;margin-left:5%;margin-right:5%;"]);
export var HeaderTitle = styled.div.withConfig({
  displayName: "style__HeaderTitle",
  componentId: "yxr7mg-10"
})(["position:relative;line-height:40px;font-weight:600;color:black;width:70%;"]);
export var Header = styled.div.withConfig({
  displayName: "style__Header",
  componentId: "yxr7mg-11"
})(["top:0;display:flex;position:relative;flex-direction:row;background-color:white;border-radius:1%;height:40px;width:100%;border-bottom:1px solid rgba(14,19,24,0.3);"]);
export var PanelContainer = styled.div.withConfig({
  displayName: "style__PanelContainer",
  componentId: "yxr7mg-12"
})(["position:absolute;display:", ";background-color:white;fill:currentColor;border-radius:1%;box-shadow:0px 4px 4px rgba(0,0,0,0.25);height:380px;width:290px;margin-top:37px;top:0;z-index:999;"], function (props) {
  return props.active ? 'inline-block' : 'none';
});
export var ButtonContainer = styled.div.withConfig({
  displayName: "style__ButtonContainer",
  componentId: "yxr7mg-13"
})(["position:relative;border-radius:10%;height:", ";width:", ";"], function (props) {
  return props.height ? props.height : '35px';
}, function (props) {
  return props.width ? props.width : '43px';
});
export var Button = styled.button.withConfig({
  displayName: "style__Button",
  componentId: "yxr7mg-14"
})(["height:", ";width:", ";border-radius:10%;padding-left:5px;padding-right:0;padding-top:5px;border-color:", ";background:", ";&:focus{outline:0;}", ":hover &{border:none;background:rgba(0,0,0,0.15);}"], function (props) {
  return props.height ? props.height : '40px';
}, function (props) {
  return props.width ? props.width : '43px';
}, function (props) {
  return props.active ? 'rgba(0, 0, 0, 0.015)' : '#33333326';
}, function (props) {
  return props.active ? 'rgba(0, 0, 0, 0.15)' : 'rgba(0, 0, 0, 0.015)';
}, ButtonContainer);
export var ShoppingCartButtonContainer = styled.div.withConfig({
  displayName: "style__ShoppingCartButtonContainer",
  componentId: "yxr7mg-15"
})(["position:relative;border-radius:10%;width:", ";margin-top:5px;margin-left:15px;"], function (props) {
  return props.width ? props.width : '35px';
});
export var ShoppingCartButton = styled.button.withConfig({
  displayName: "style__ShoppingCartButton",
  componentId: "yxr7mg-16"
})(["width:", ";height:", ";padding-top:0px;padding-left:4px;background-color:#fff;border-color:#fff;box-shadow:#fff;&:focus{outline:0;border-color:#fff;}border-radius:4px;", ":hover &{background:rgba(0,0,0,0.115);background-color:rgba(0,0,0,0.115);}"], function (props) {
  return props.width ? props.width : '35px';
}, function (props) {
  return props.height ? props.height : '35px';
}, ShoppingCartButtonContainer);
export var PaymentButtonContainer = styled.div.withConfig({
  displayName: "style__PaymentButtonContainer",
  componentId: "yxr7mg-17"
})(["position:absolute;height:100px;width:100%;padding-top:10px;text-align:center;"]);
export var PaymentButton = styled.button.withConfig({
  displayName: "style__PaymentButton",
  componentId: "yxr7mg-18"
})(["font-weight:600;background-color:#99c432;border-color:#99c432;line-height:35px;width:180px;margin:auto;box-shadow:#99c433;&:focus{outline:0;border-color:#99c433;}border-radius:4px;", ":hover &{background:#99c433;}"], PaymentButtonContainer);
export var ItemContainer = styled.div.withConfig({
  displayName: "style__ItemContainer",
  componentId: "yxr7mg-19"
})(["background-color:white;height:90px;width:100%;margin-top:15px;border-bottom:1px solid rgba(0,0,0,0.15);flex-direction:column;overflow-y:scroll;max-height:400px;"]);
export var ShoppingCartIcon = styled.div.withConfig({
  displayName: "style__ShoppingCartIcon",
  componentId: "yxr7mg-20"
})(["height:35px;width:100%;margin:auto;background-image:", ";border-radius:4px;"], shopping_cart);
export var TotalTitle = styled.div.withConfig({
  displayName: "style__TotalTitle",
  componentId: "yxr7mg-21"
})(["font-weight:500;line-height:2;position:relative;height:25px;width:80%;margin-left:12px;color:rgba(14,19,24,0.9);margin-right:12px;text-align:right;"]);